import { City, State } from "country-state-city";
import React, { useEffect, useState } from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import {Autocomplete,TextField} from "@mui/material";

const AddressForm = ({ validation, fieldPath = "primaryBranch" }) => {
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const getValue = (field) =>
    validation?.values?.[fieldPath]?.[field] || "";

  const getError = (field) =>
    validation?.touched?.[fieldPath]?.[field] &&
    validation?.errors?.[fieldPath]?.[field];

  useEffect(() => {
    setStates(State.getStatesOfCountry("IN"));
  }, []);

  useEffect(() => {
    const selectedState = states.find((s) => s.name === getValue("state"));
    if (selectedState) {
      setCities(City.getCitiesOfState("IN", selectedState.isoCode));
    } else {
      setCities([]);
    }
  }, [getValue("state"), states]);

  return (
    <>
      <FormGroup>
        <Label>Address Line 1</Label>
        <Input
          type="text"
          name={`${fieldPath}.addressLine1`}
          placeholder="Enter Address Line 1"
          value={getValue("addressLine1")}
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          invalid={getError("addressLine1")}
        />
        {getError("addressLine1") && (
          <p style={{ color: "red" }}>
            {validation.errors[fieldPath].addressLine1}
          </p>
        )}
      </FormGroup>

      <FormGroup>
        <Label>Address Line 2</Label>
        <Input
          type="text"
          name={`${fieldPath}.addressLine2`}
          placeholder="Enter Address Line 2"
          value={getValue("addressLine2")}
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
        />
      </FormGroup>

      <Row>
        <Col>
      <FormGroup>
        <Label>State</Label>
        <Input
          type="select"
          name={`${fieldPath}.state`}
          value={getValue("state")}
          onChange={(e) => {
            validation.handleChange(e);
            validation.setFieldValue(`${fieldPath}.city`, "");
          }}
          onBlur={validation.handleBlur}
          invalid={!!getError("state")}
        >
          <option value="">Select State</option>
          {states.map((state) => (
            <option key={state.isoCode} value={state.name}>
              {state.name}
            </option>
          ))}
        </Input>
        {getError("state") && (
          <p style={{ color: "red" }}>
            {validation.errors[fieldPath].state}
          </p>
        )}
      </FormGroup>
      </Col>
      <Col>
      <FormGroup>
        <Label>City</Label>
       <Autocomplete
       options={cities}
       getOptionLabel={(option) => option.name || ""}
       value={cities.find((c) => c.name === getValue("city")) || null}
       onChange={(event, value) => {
        validation.setFieldValue(`${fieldPath}.city`, value?.name || "");
      }}
      onBlur={() => {
        validation.setFieldTouched(`${fieldPath}.city`, true);
      }}
      renderInput={(params) => (
      <TextField
      disableClearable
      {...params}
      placeholder="Select City"
      variant="outlined"
      size="small"
      error={!!getError("city")}
      helperText={null}
      sx={{
        "& .MuiOutlinedInput-root": {
          height: "33px",
          fontSize: "14px",
        "& .MuiOutlinedInput-input::placeholder": {
          fontSize:"14px",
          color: "#1e2124",
          opacity: 1,
        },        
        "& fieldset": {
        borderColor: "#ced4da", 
      },
      "&.Mui-focused fieldset": {
        borderColor: "#86b7fe", 
        boxShadow: "0 0 0 0.2rem rgba(0, 123, 255, 0.25)",
      },
      "&.Mui-error fieldset": {
        borderColor: "#f92439", 
        
      },
      "&.Mui-focused.Mui-error fieldset":{
         borderColor: "#f92439", 
        boxShadow: "0 0 0 0.2rem rgba(249, 36, 57, 0.25)",
        borderWidth: "1px",

      }
    },
   
  }}
  />
  )}
/>
{getError("city") && (
  <div className="text-danger mt-1">{getError("city")}</div>
)}
      </FormGroup>
      </Col>
      <Col>
      <FormGroup>
        <Label>Pincode</Label>
        <Input
  type="text"
  name={`${fieldPath}.pincode`}
  placeholder="Enter Pincode"
  value={getValue("pincode")}
  inputMode="numeric"   
  pattern="[0-9]*"      
  maxLength="6"
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, ""); 
    validation.setFieldValue(`${fieldPath}.pincode`, value);
  }}
  onBlur={validation.handleBlur}
  invalid={!!getError("pincode")}
/>
        {getError("pincode") && (
          <p style={{ color: "red" }}>
            {validation.errors[fieldPath].pincode}
          </p>
        )}
      </FormGroup>
      </Col>
      </Row>
    </>
  );
};

export default AddressForm;